export const filterShopCategories = (
  category: any,
  hiddenCategories: string[],
): boolean => {
  return (
    category.mainCategory.subCategories?.length &&
    !hiddenCategories.includes(category.mainCategory.id)
  )
}
